import type { AppPaneName, HeaderPaneName } from "owa-app-pane-group-types";
import { APP_PANE_NAME_PREFIX, HEADER_PANE_NAME_PREFIX } from "./constants/constants";
import isAppPane from "./utils/isAppPane";
import isHeaderPane from "./utils/isHeaderPane";

export default function getDrawerPaneId(name: AppPaneName | HeaderPaneName): string {
    if (isAppPane(name)) {
        return `${APP_PANE_NAME_PREFIX}${name}`;
    }
    else if (isHeaderPane(name)) {
        return `${HEADER_PANE_NAME_PREFIX}${name}`;
    }
    return name;
}
